// extracted by mini-css-extract-plugin
module.exports = {"root":"TableSection_root__3iHAk","searchInput":"TableSection_searchInput__54V7_","filterGroup":"TableSection_filterGroup__6vBYN"};